import { message } from 'antd';
import $ from '../scripts/events'
import './config'
import 'whatwg-fetch';
const codeMessage = {
    200: '服务器成功返回请求的数据。',
    201: '新建或修改数据成功。',
    202: '一个请求已经进入后台排队（异步任务）。',
    204: '删除数据成功。',
    400: '发出的请求有错误，服务器没有进行新建或修改数据的操作。',
    401: '用户没有权限（令牌、用户名、密码错误）。',
    403: '用户得到授权，但是访问是被禁止的。',
    404: '发出的请求针对的是不存在的记录，服务器没有进行操作。',
    406: '请求的格式不可得。',
    407: '登录超时，请重新登录',
    408: '账号在其他地方登录，您已经被强制下线',
    410: '请求的资源被永久删除，且不会再得到的。',
    422: '当创建一个对象时，发生一个验证错误。',
    500: '服务器发生错误，请检查服务器。',
    502: '网关错误。',
    503: '服务不可用，服务器暂时过载或维护。',
    504: '网关超时。',
};

const defaultIndex = 1;//默认数据来源序号
const reqFrom = {
    1: 'PC',//PC端

    2: 'APP',//APP
    3: 'WeXin',//微信
    4: 'aliPay',//支付宝

    5: 'Mob'//其他移动端

}
//返回独享解析
function parseJSON(response) {
    return response.json();
}
//校验返回对象
function checkStatus(response) {
    if (response.status >= 200 && response.status < 400) {
        return response
    }
    else {
        message.error(codeMessage[response.status]);
        const error = new Error(response.statusText)
        error.response = response
        throw error
    }
}
///检查返回值状态

function statusCodeCheck(response) {
    const code = response.statusCode;
    message.destroy();
    if (code === '200' || code === '201' || code === '202' || code === '204') {
        return response;
    }
    else {
        let _message = response.message || '未返回正确的错误信息';
        if (code === null || code === undefined) {
            _message = "后台处理状态值返回异常或者没有对应的处理函数"
        }
        message.error(_message, 3, () => {
            if (code === '407' || code === '408') {
                //重新登录
                message.warning('登录已经过期，请重新登录', 5, () => {
                    $.emit('reLogin', {});
                })
            }
        });
        return null;
    }
}
//对象转字符串拼接
function objParams(data) {
    let result = '';
    let item;
    for (item in data) {
        if (data[item] !== undefined && data[item] !== null) {
            result += '&' + item + '=' + encodeURIComponent(data[item]);
        }
        else {
            result += '&' + item + '=';//为undefined是要传空值到后台，表示本次提交了该字段且该字段为空值

        }
    }
    //加上默认参数
    result += '&reqFrom=' + encodeURIComponent(reqFrom[defaultIndex]);
    //加上令牌
    result += '&access_token=' + encodeURIComponent(localStorage.getItem('ssas_access_token'));
    //加上文件存储地址
    result += '&fileAddress=' + encodeURIComponent(global.constants.fileAddress);
    //加上操作员信息

    const objUser = localStorage.getItem('userStorage');
    if (objUser != '' && objUser != null && objUser != undefined) {
        const objCzy = JSON.parse(objUser);
        result += '&czyid=' + encodeURIComponent(objCzy.czyid);
        result += '&czy_ksid=' + encodeURIComponent(objCzy.czy_ksid || objCzy.ksid);
    }
    result += '&APPTYPE=' + encodeURIComponent('PC');
    if (result) {
        result = result.slice(1);
    }
    return result;
}
/*数据提交*/
export default function request(options = {}, tips = {}) {
    const { data, url } = options
    options = { ...options }
    //options.mode = 'cors'
    if (data) {
        delete options.data
        options.body = objParams(data);
    }
    if (tips.loading) {
        message.loading(tips.msg || '请求发送中,请稍等...', 300);
    }
    delete options.url
    delete tips.loading
    delete tips.msg

    let _httpaddress=global.constants.address;
    if(options.audio){
        _httpaddress=global.constants.aiaddress;
    }
    if (options.yygl) {
      _httpaddress=global.constants.yygladdress;
    }
    options.headers = {
        'Accept': 'application/json,text/plain,*/*',
        'Content-Type': 'application/x-www-form-urlencoded'
    }
    let _fetch = fetch(_httpaddress + url, options)
        .then(checkStatus)
        .then(parseJSON)
        .then(statusCodeCheck)
        .catch(err => {
            message.destroy();
            setTimeout(() => {
                message.error('服务器连接异常,请稍后再试');
            }, 300);
            
        });

    return _fetch;
}